const LocalStorageConst = {
    TrafficAreasGeography: 'trafficAreasGeography'
}

export default LocalStorageConst;